import { render } from "./CardSec.vue?vue&type=template&id=3b9fc644"
import script from "./CardSec.vue?vue&type=script&lang=js"
export * from "./CardSec.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__